/*
 * @Author: 黄悦凯 huangyuekai@jafron.com
 * @Date: 2025-11-26 11:51:04
 * @LastEditors: 黄悦凯 huangyuekai@jafron.com
 * @LastEditTime: 2025-12-02 11:58:44
 * @FilePath: \carpooling-vue\src\util\api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const api = {
    //查询登录用户数据
    getUserInfo: '/api/UserCar/getUserCarInfo',
    //获取司机路线信息
    getDriverRoute: '/api/UserCar/getDriverRouteByOpenid',
    //获取所有司机路线信息
    getAllRouteList: '/api/UserCar/getAllRouteList',
    //新增或更新用户信息
    postUserCar: '/api/UserCar/postUserCarInfo',
    // 获取已订阅司机列表
    getSubscribeList: '/api/UserCar/getSubscribeList',
    // 取消订阅司机
    postCancelSubscribe: '/api/UserCar/postCancelSubscribe',
    //新增或更新司机路线信息
    postUserRoute: '/api/UserCar/postUserRoute',
    //司机发布行程信息
    postAddTravel: '/api/UserCar/postAddTravel',
    //新增乘客拼车数据
    postPassengerInfo: '/api/UserCar/postPassengerInfo',
    //获取当前日期乘客拼车情况
    getPassengerByOpenid: '/api/UserCar/getPassengerByOpenid',
    //更新行程信息
    postUpdateTravel: '/api/UserCar/postUpdateTravel',
    //乘客取消行程，删除数据
    deletePassenger: '/api/UserCar/deletePassengerData',
    //获取乘客拼车列表
    getPassengerList: '/api/UserCar/getPassengerList',
    // 给用户推送应用信息
    postSendMessageWX: '/api/WXAuthorize/postSendMessageWX',

    getUserListByDepartment: '/api/WXAuthorize/getUserListByDepartment',
    getDepartmentUserbyQW: '/api/WXAuthorize/getDepartmentUserbyQW',
    getDepartmentList: '/api/WXAuthorize/getDepartmentList',
    getAllDepartmentList: '/api/WXAuthorize/getAllDepartmentList',
    searchUser: '/api/WXAuthorize/searchUser',
    getUserDetail: '/api/WXAuthorize/getUserDetail',
    // 用户反馈提交
    postFeedBack: '/api/UserCar/postFeedBackInfo',
    // 异常单新增或更新
    postAbnormal: '/api/UserCar/postAbnormalInfo',
    // 获取异常提交列表
    getAbnormalList: '/api/UserCar/getAbnormalList',
    // 获取用户当月补单额度
    getAbnormalQuota: '/api/UserCar/getAbnormalQuota',
    // 拒绝补单
    rejectAbnormal: '/api/UserCar/rejectAbnormal',
    // 司机获取日期内乘客数据
    getTravelList: '/api/Commute/getTravelList',
    // 获取公交车站牌
    getSiteList: '/api/GoWork/getSiteList',
    // 获取百度地图地点检索api
    getBaiDuSiteList: '/api/GoWork/getBaiDuSiteList',
    // 获取用户平台注册数据
    getUserInfoFormWork: '/api/GoWork/getUserInfo',
    // 新增或更新 早班车用户数据
    postWorkUser: '/api/GoWork/postWorkUser',
    // 清除早班拼车注册及关联行程数据（重新注册）
    deleteWorkUserRegistration: '/api/GoWork/deleteWorkUserRegistration',
    // 获取早班车用户数据 关联用户基础注册表 关联乘客或司机 数据
    getWorkUserInfo: '/api/GoWork/getWorkUserInfo',
    // 根据司机工号获取早拼乘客用户列表
    getPassengerListByDriverId: '/api/GoWork/getPassengerList',
    // 新增或者更新 早班车行程
    postWorkTravel: '/api/GoWork/postWorkTravel',
    // 司机发车设置：自动发车开关 + 不发车日期
    getDriverDepartConfig: '/api/GoWork/getDriverDepartConfig',
    postDriverAutoDepart: '/api/GoWork/postDriverAutoDepart',
    postDriverSkipDate: '/api/GoWork/postDriverSkipDate',
    deleteDriverSkipDate: '/api/GoWork/deleteDriverSkipDate',
    postManualWorkTravel: '/api/GoWork/postManualWorkTravel',
    // 获取早班车动态乘车码
    getDynamicQRCode: '/api/GoWork/getDynamicQRCode',
    // 乘客扫码确认上车
    scanConfirmBoarding: '/api/GoWork/scanConfirmBoarding',
    // 获取早班车行程信息 乘客拼车记录为主表
    getWorkTravel: '/api/GoWork/getWorkTravel',
    // 删除早班车行程
    deleteTravel: '/api/GoWork/deleteWorkTravelData',
    // 获取早班车司机列表 关联乘客数据
    getWorkDriverList: '/api/GoWork/getWorkDriverList',
    // 删除早班车行程 乘客记录
    deleteWorkPassengerApi: '/api/GoWork/deleteWorkPassengerData',
    // 乘客行程记录获取司机行程
    getWorkTravelFromPassenger: '/api/GoWork/getWorkTravelFromPassenger',
    // 新增或更新通用api
    postUpDataOrCreateApi: '/api/GeneralMethod/postUpDataOrCreate',
    // 根据条件获取数据
    getFunctionByQuery: '/api/GeneralMethod/getFunctionByQuery',
    // 删除数据通用api
    deleteFunction: '/api/GeneralMethod/deleteFunction',
    //获取企微客户详情
    getCustomerDetail: '/api/WXAuthorize/getCustomerDetail',
    // 获取生命周期医护信息
    getUserInfoFromQuanByOpenId: '/api/servicerIM/getUserByOpenid',

    // 授权企业微信SDK
    getWXSign: '/api/WXAuthorize/getWXSign',

    // 同步数据IM
    SynchronousData: '/api/servicerIM/SynchronousData',

    // 班车二维码 获取用户数据
    postQRcodeData: '/api/Commute/postQRcodeData',

    // 人人都是品牌官
    // 提交打卡
    clockIn: '/api/ClockIn/postCheckInRecord',
    // 获取打卡记录
    getMyCheckInList: '/api/ClockIn/getMyCheckInList',
    // 全量打卡列表
    getCheckInList: '/api/ClockIn/getCheckInList',
    // 素材管理-上传素材
    uploadMaterial: '/api/ClockIn/postMaterial',
    // 素材管理-获取素材列表
    getMyMaterialList: '/api/ClockIn/getMyMaterialList',
    // 综合评分榜
    getScoreBoard: '/api/ClockIn/getScoreBoard',
    // 更新单条评分
    updateScoreBoard: '/api/ClockIn/updateScoreBoard'
}